import type { Author } from '../data/authors'

// Abstract badge avatars, not photos — in keeping with preppers' general
// preference for anonymity/OPSEC. Each is a circular instrument-style badge
// (matches the compass-bezel visual language elsewhere on the site) with a
// single glyph representing that author's specialty.
const ICONS: Record<Author['icon'], React.ReactNode> = {
  compass: (
    <path d="M32 14 L36 32 L32 50 L28 32 Z M14 32 L32 28 L50 32 L32 36 Z" fillRule="evenodd" />
  ),
  bolt: <path d="M35 12 L20 36 H30 L28 52 L45 26 H34 Z" />,
  leaf: (
    <path d="M32 14 C46 14 50 28 50 38 C38 38 32 32 32 32 C32 32 26 38 14 38 C14 28 18 14 32 14 Z M32 32 L32 52" fill="none" stroke="currentColor" strokeWidth={2.4} />
  ),
  jar: (
    <path
      d="M24 16 H40 V22 H42 C43 22 44 23 44 24 V48 C44 50 42 52 40 52 H24 C22 52 20 50 20 48 V24 C20 23 21 22 22 22 H24 Z M24 22 H40"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.4}
    />
  ),
}

export default function AuthorAvatar({ author, size = 64 }: { author: Author; size?: number }) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className="author-avatar"
      role="img"
      aria-label={`${author.name}, abstract badge avatar (anonymized, no photo)`}
    >
      <circle cx="32" cy="32" r="30" fill="var(--panel)" stroke="var(--line-strong)" strokeWidth="1.5" />
      <circle cx="32" cy="32" r="25" fill="none" stroke="var(--line)" strokeWidth="1" strokeDasharray="1.5 3" />
      <g fill="var(--signal)" stroke="var(--signal)">
        {ICONS[author.icon]}
      </g>
    </svg>
  )
}
